import React, { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';
import styled from 'styled-components';
import { Button, FlexView, Separator, Text, COLORS } from '@cuemath/comps';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import { postStudent } from 'actions/parent-lead';
import { bindActionCreators } from 'redux';
import { async, store } from 'redux-rest-reducer';
const ButtonContainer = styled(FlexView)`
  padding: 10px;
`;

const WarningPopup = ({ message, warningAccepted, parentId, parentStudents, error }) => {
  const [open, setOpen] = useState(true);
  const closeModal = () => setOpen(false);
  let postParentStudentsResponse = store.post(parentStudents, parentId) || {};
  const { resolved = {} } = postParentStudentsResponse || {};
  const { isCreating = '', isCreated = '', isCreatingFailed = '' } = resolved || {};
  useEffect(() => {
    if (isCreated) {
      closeModal();
    } else {
      setOpen(true);
    }
  }, [isCreated]);

  return message ? (
    <div>
      <Popup
        open={open}
        closeOnDocumentClick
        onClose={closeModal}
        contentStyle={{
          width: '30%',
          border: `1px solid ${COLORS.BLACK}`,
          padding: '5px 10px',
          fontSize: '14px',
          backgroundColor: `${COLORS.WHITE}`,
        }}
      >
        <Text weight="bold">{error}. Are you sure you want to go ahead?</Text>
        <ButtonContainer>
          <Button renderAs="primary" label="Yes" onClick={warningAccepted} />
          <Separator transparent height={15} />
          <Button renderAs="primary" label="No" onClick={() => setOpen(false)} />
        </ButtonContainer>
      </Popup>
    </div>
  ) : null;
};

export default connect(
  ({ parentStudents }, { location: { search } = {} }) => {
    const searchObj = parse(search);

    return {
      parentStudents,
      searchObj,
    };
  },
  dispatch => ({
    actions: bindActionCreators({ postStudent }, dispatch),
  }),
)(WarningPopup);
